import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import colors from "vuetify/lib/util/colors";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    defaultTheme: "dark",
    themes: {
      light: {
        primary:
          process.env.NODE_ENV == "development"
            ? colors.blueGrey.darken4
            : colors.green.darken4,
        colormenuselect:
          process.env.NODE_ENV == "development"
            ? colors.blueGrey.lighten5
            : colors.green.lighten5,
      },
    },
  },
});
